import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "wrap" }
const _hoisted_2 = { class: "table-wrap" }
const _hoisted_3 = { class: "HtmlUnit" }
const _hoisted_4 = { colspan: "9" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import { sections } from '@/view/MarkupView/sections';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkupPage',
  setup(__props) {

const router = useRouter();

const resolveRoute = (path) => router.resolve(path).href;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-wrap" }, [
      _createElementVNode("div", { id: "header" }, [
        _createElementVNode("h1", null, "CalIt 마크업리스트"),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createTextVNode("Version: "),
            _createElementVNode("b", null, "0.2.")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode("Last Update: "),
            _createElementVNode("b", null, "2024-12-19")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode("Coding: "),
            _createElementVNode("b", null, "Vue&Typescript")
          ])
        ])
      ]),
      _createElementVNode("p", null, "Router 링크는 프로젝트 내의 페이지로 연결되며, Design Link는 Figma의 디자인 링크로 연결됩니다.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "head" }, [
            _createElementVNode("td", null, "No"),
            _createElementVNode("td", null, "Path"),
            _createElementVNode("td", null, "Page Name"),
            _createElementVNode("td", null, "Description"),
            _createElementVNode("td", null, "Router Link"),
            _createElementVNode("td", null, "Design Link(PC)"),
            _createElementVNode("td", null, "Design Link(mobile)")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: section.title
            }, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(section.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.fileName
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.path), 1),
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: resolveRoute(item.path),
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "Router 링크", 8, _hoisted_5)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: item.designLinkPC,
                      target: "_blank"
                    }, "PC 디자인", 8, _hoisted_6)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: item.designLinkMobile,
                      target: "_blank"
                    }, "Mobile 디자인", 8, _hoisted_7)
                  ])
                ]))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})